import { MerchantPayoutIncrementTaxes } from "features/paymentMethods/types";
import { usePaymentMethodsContext } from "../PaymentMethodsProvider";

export const useFeesAndCommisions = () => {
    const { paymentMethod } = usePaymentMethodsContext();

    const getMethodFees = () => (
        paymentMethod?.merchantPayoutIncrementTaxes ?? []
    );

    const groupIncrementTaxesBy = ({
        groupByKey: propKey,
        incrementTaxes = getMethodFees()
    }: {
        readonly groupByKey: keyof MerchantPayoutIncrementTaxes,
        readonly incrementTaxes?: Array<MerchantPayoutIncrementTaxes>;
    }) => (
        (Object as any).groupBy(
            incrementTaxes,
            ({ [propKey]: groupKey }: MerchantPayoutIncrementTaxes) => groupKey
        )
    );

    return {
        getMethodFees,
        groupIncrementTaxesBy
    };
};

export default useFeesAndCommisions;
